/// <reference types="@types/googlemaps" />

import { Component, OnInit } from '@angular/core';

import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { ToastrService } from 'ngx-toastr';
import { AnalysisService } from 'src/app/services/analysis.service';
import { ITimeline } from '../interfaces/timeline';
import { ITimelineItem } from '../interfaces/timelineItem';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.css']
})
export class AnalysisComponent implements OnInit {

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private analysisService: AnalysisService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
  }

  //LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  id = JSON.parse(this.localID);
  facilities = JSON.parse(this.localFacilities);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facilities[this.id];

  //Icon NavBar
  markerImage: any = require("src/app/image/logo/locationIcon.png");
  homeImage: any = require("src/app/image/navbar/backHomeIcon.svg");
  summaryImage: any = require("src/app/image/navbar/summary.svg");
  analysisImage: any = require("src/app/image/navbar/analysis.svg");
  roiImage: any = require("src/app/image/navbar/roi.svg");
  mdiImage: any = require("src/app/image/navbar/mdi.svg");
  pprImage: any = require("src/app/image/navbar/ppr.svg");

  lng: any;
  lat: any;
  zoom: number;

  timeline: ITimeline;

  itemTimeline: Array<ITimelineItem> = [];
  currentPage: number = 0;
  itemsNumberPerPage: number = 10;

  modalReference: any;

  partialState: string = null;
  notStartedState: string = null;

  analysisStatus = null;

  isOpen: boolean;
  _opened: boolean = false;


  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    this.createGoogleMap();

    this.getTimeline(this.currentPage);

    localStorage.removeItem('localIDElaboration');
    localStorage.removeItem('localStateAnalysis');
    localStorage.removeItem('localSurveyCompiled');
    localStorage.removeItem('localPages');
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  cardStructureOpen() {
    this.isOpen = true;
  }

  cardStructureClose() {
    this.isOpen = false;
  }

  //Method used to create a map of current Structure.
  createGoogleMap() {
    if (navigator) {
      this.lng = this.currentFacility.myFacilities.Longitude;
      this.lat = this.currentFacility.myFacilities.Latitude;
      this.zoom = 13;
    }
  }

  //API Return Timeline
  getTimeline(currentPage: number) {
    //Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, this.modules, currentPage, this.itemsNumberPerPage)
      .subscribe(
        data => {
          this.timeline = data;

          for (let item of this.timeline.items)
            this.itemTimeline.push(item);

          //Control the display of buttons to view the questionnaire or fill it out.
          for (let element of this.timeline.items) {

            switch (element.state) {
              case 'CompilazioneConclusa': {
                break;
              }

              case 'CompilazioneParziale': {
                this.partialState = element.state;
                break;
              }

              case 'CompilazioneNonAvviata': {
                this.notStartedState = element.state;
                break;
              }
            }
            break;
          }

          // Controllare il bottone di  richiedi aggiornamento
          //Control the display of button to update Analisys of current facility.
          for (let element of this.timeline.items) {
            switch (element.label) {
              case 'Avvio analisi': {
                if (element.state == 'RichiestaDiAggiornamento') {
                  this.analysisStatus = true;
                }
                if (element.state == 'ElaborazioneEseguita') {
                  this.analysisStatus = false;
                }
              }
            }

          }

          if ((data.currentPage + 1) * data.requestItemsNumberPerPage < data.totalItemsCount) this.getTimeline(data.currentPage + 1);
        },
        error => {
          this.router.navigate(['/errorPage']);
        }
      );
  }

  //API Request update current facility.
  updateRequest() {
    //Call Api of Analys service to request update of current facility.
    this.analysisService.updateRequest(this.currentFacility.myFacilities.ID, this.currentFacility.myFacilities.IdTag)
      .subscribe(
        data => {
          this.close();
          this.itemTimeline = [];
          this.getTimeline(this.currentPage);
          this.translate.get('UPDATE_REQUEST_200.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          });
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  //Method used to open Modal of Request Update Analysis.
  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, { centered: true });
  }

  //Method used to close Modal of Request Update Analysis.
  close() {
    this.modalReference.close();
  }

  //Method used to get ID Elaboration, State of Analysis for Survey component.
  getSurvey(id, state) {
    localStorage.setItem('localIDElaboration', JSON.stringify(id));
    localStorage.setItem('localStateAnalysis', JSON.stringify(state));
    //Go to Survey Component.
    this.router.navigate(['/survey'])
  }

  //Method used to get ID Elaboration, for Dashboard component.
  getDashboard(id) {
    localStorage.setItem('localIDElaboration', JSON.stringify(id));
    //Go to Dashboard Component.
    this.router.navigate(['/dashboard'])
  }
}
